module.exports = __webpack_public_path__ + "img/img_body_biz_channeltalk_logo.8714ed8d.png";